import { useState } from 'react'

interface PhoneFormProps {
  initialValues?: { name: string; sim: string }
  onSubmit: (data: { name: string; sim_number: string }) => void
  onCancel: () => void
  isPending: boolean
  error?: Error | null
}

export function PhoneForm({ initialValues, onSubmit, onCancel, isPending, error }: PhoneFormProps) {
  const [name, setName] = useState(initialValues?.name || '')
  const [simNumber, setSimNumber] = useState(initialValues?.sim || '')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSubmit({ name: name.trim(), sim_number: simNumber.trim() })
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <p className="text-red-500 text-sm">{error.message}</p>
      )}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Name
        </label>
        <input
          type="text"
          placeholder="Pixel 7"
          value={name}
          onChange={e => setName(e.target.value)}
          required
          className="w-full rounded-lg border border-gray-300 dark:border-gray-700
            bg-white dark:bg-gray-800 px-4 py-2.5
            text-gray-900 dark:text-gray-100
            placeholder-gray-400 dark:placeholder-gray-500
            focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          SIM Number
        </label>
        <input
          type="tel"
          placeholder="+7 999 123 4567"
          value={simNumber}
          onChange={e => setSimNumber(e.target.value)}
          required
          className="w-full rounded-lg border border-gray-300 dark:border-gray-700
            bg-white dark:bg-gray-800 px-4 py-2.5
            text-gray-900 dark:text-gray-100
            placeholder-gray-400 dark:placeholder-gray-500
            focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex justify-end gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300
            hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isPending || !name.trim() || !simNumber.trim()}
          className="px-4 py-2 text-sm font-medium rounded-lg bg-blue-600 hover:bg-blue-700
            disabled:opacity-50 disabled:cursor-not-allowed
            text-white transition-colors"
        >
          {isPending ? 'Saving...' : (initialValues ? 'Save' : 'Create')}
        </button>
      </div>
    </form>
  )
}
